import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { getStyle } from './utils.es.js';
import styled from '@emotion/styled';
import React from 'react';

const Box = React.forwardRef((props, ref) => {
    const { commonStyle, children } = props, rest = __rest(props, ["commonStyle", "children"]);
    return (jsx(Wrapper, Object.assign({ commonStyle: commonStyle }, rest, { ref: ref }, { children: children })));
});
const Wrapper = styled.div(({ commonStyle }) => `
    position: relative;
    display: flex;
    ${getStyle(commonStyle)}
`);
Box.displayName = 'Box';

export { Box as B };
